import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col, Modal, ProgressBar, Button, Tab, Tabs, Form, Table, Dropdown, Badge, } from 'react-bootstrap';
import { faPlus, faXmark, faCircle, faCaretDown, faPaperclip, faBolt, faEllipsis, faLink, faCircleCheck, faChevronDown, faGear, faPencil, faBarcode, faRotateRight } from '@fortawesome/free-solid-svg-icons';
import Slider from "react-slick";

import Docmnt from '../../../../assets/images/google-docs.png';
import MailGreen from '../../../../assets/images/mail_at.png';
import Mailred from '../../../../assets/images/mail_dlt.png';
import OfficeIn from '../../../../assets/images/in_office.png';
import OfficeOut from '../../../../assets/images/no_office.png';
import Cargoplane from "../../../../assets/images/plane.svg";
import Loading from "../../../../assets/images/loading.png";
import Unloading from "../../../../assets/images/Unloading.png";
import pen from "../../../../assets/images/pen.png";
import Cargotruck from "../../../../assets/images/cargo-truck.png";
import Cuser from "../../../../assets/images/cuser.png";
import Rapdf from "../../../../assets/images/pdf.png";
import Trash from '../../../../assets/images/trash.png';
import Planned from "../../../../assets/images/planned2.png";
import Schdule from "../../../../assets/images/tracking2.png";
import Tripimg from "../../../../assets/images/edit.png";
import Showdetails from "../../../../assets/images/show.png";
import DelayD from "../../../../assets/images/delay_not_active.png";
import DelayA from "../../../../assets/images/delay_active.png";
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import ImageUpload from '../../../../Pages/Forwarder/ShipmentManager/Components/Common/ImageUpload';
import ActivityComments from '../../../../Components/common/ActivityComments';


import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import { TRUCKORDERSDETAILS, SLOTPLANNINGWAREHOUSE, SLOTPLANNINGAVAILABLESLOTCOUNT } from '../../../../Utils/conts.js';
import Select from 'react-select';
import Loader from '../../../../Components/common/Loader.js';
import { jqxCookieCall } from '../../../../Components/common/CommonFunctions.js';
const OrdersView = ({ applyFilter, filterData, setApplyFilter, resetGrid, order_type, selectedStation, onDetails }) => {
    const isMounted = useRef(false);
    const [isLoading, setIsLoading] = useState(true);
    const [disLoading, setDisLoading] = useState(false);
    const user = localStorage.getItem('RFS');
    const [filterApplied, setFilterApplied] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [modalData, setModalData] = useState({});
    const [editStatusIndex, setEditStatusIndex] = useState(false);
    const [statusData, setStatusData] = useState([]);
    const [awbsData, setAwbsData] = useState([]);
    const [confirmFormData, setConfirmFormData] = useState([]);
    const [allAvailableSlotCount, setAllAvailableSlotCount] = useState([]);
    const [gridData, setGridData] = useState([]);

    const [selectedRowData, setSelectedRowData] = useState(null);
    const [gridSelect, setGridSelect] = useState([]);
    const gridRef = useRef(null);
    const orderTypeTab = localStorage.getItem("slotOrderTypeTab");
    const [activeTab, setActiveTab] = useState(orderTypeTab || 'All');
    const gridRefs = {
        All: useRef(null),
        Loading: useRef(null),
        Unloading: useRef(null),
        Archived: useRef(null),
    };
    const [moveToComplete, setMoveToComplete] = useState(false);
    const [schdlModal, setSchdlModal] = useState(false);
    const [confirmEmailModal, setConfirmEmailModal] = useState(false);
    const [schdlModalData, setSchdlModalData] = useState('');
    const [timeData, setTimeData] = useState();
    const [warehouselist, setWarehouselist] = useState([]);

    const handleTabChange = async (tab) => {

        setActiveTab(tab);
        setIsLoading(true);
        setFilterApplied(false);
        if (selectedRowData) {
            setSelectedRowData(null)
        }
        setGridSelect([]);
        if (tab == 'All') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ All: {} });
            }, 1);
        } else if (tab == 'Loading') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Loading: {} });
            }, 1);
        } else if (tab == 'Unloading') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Unloading: {} });
            }, 1);
        } else if (tab == 'Archived') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Archive: {} });
            }, 1);
        } else {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Archive: {} });
            }, 1);
        }
    };

    useEffect(() => {
        if (applyFilter && gridRefs[activeTab].current) {
            // window.$(gridRefs[activeTab].current).jqxGrid("clearfilters");
            // window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");
            Object.keys(filterData).forEach((field) => {
                const filterValue = filterData[field];


                if (filterValue !== null && filterValue !== undefined) {
                    const filterGroup = new window.$.jqx.filter();
                    const filterCondition = "CONTAINS"; // Adjust the condition as needed
                    const filter = filterGroup.createfilter("stringfilter", filterValue, filterCondition);

                    filterGroup.addfilter(1, filter);
                    window.$(gridRefs[activeTab].current).jqxGrid("addfilter", field, filterGroup);
                }
            });
            window.$(gridRefs[activeTab].current).jqxGrid("applyfilters");
            setApplyFilter(false); // Reset the applyFilter flag
        }
    }, [applyFilter, filterData, setApplyFilter]);

    useEffect(() => {
        if (order_type && gridRefs[activeTab]?.current) {
            const filterGroup = new window.$.jqx.filter();
            const filterCondition = "EQUAL"; // or "CONTAINS", based on your requirement
            const filter = filterGroup.createfilter("stringfilter", order_type, filterCondition);
            filterGroup.addfilter(1, filter);

            window.$(gridRefs[activeTab].current).jqxGrid("addfilter", "order_type", filterGroup);
            window.$(gridRefs[activeTab].current).jqxGrid("applyfilters");
        }
    }, [order_type, activeTab]);


    useEffect(() => {
        if (isMounted.current) return;
        // Call the fetchData function to fetch data from the API
        // fetchDataGrid();
        // const savedFilter = localStorage.getItem('ovFilter');
        // if (savedFilter) {
        //     const parsedFilter = JSON.parse(savedFilter);

        //     setTimeout(() => {
        //         const grid = window.$(gridRefs[activeTab]?.current);
        //         parsedFilter.forEach(filter => {
        //             grid.jqxGrid('addfilter', filter.datafield, {
        //                 operator: filter.operator,
        //                 value: filter.value,
        //                 condition: filter.condition,
        //                 type: filter.type
        //             });
        //         });

        //         grid.jqxGrid('applyfilters');
        //     }, 500); // wait for grid to render
        // }
        setIsLoading(false);
        setGridData({ All: [] });
        fetchWareHouseData();
        isMounted.current = true;
    }, []);

    const fetchWareHouseData = async () => {
        try {
            let Handler_stn = localStorage.getItem('Handler_stn');
            if (!Handler_stn) {
                return;
            }
            Handler_stn = JSON.parse(Handler_stn);
            const res = await withRFSToken.post(SLOTPLANNINGWAREHOUSE, { org_station_id: Handler_stn.org_station_id })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const warehouseOptions = [
                        ...innerData.map(w => ({
                            label: w.name,
                            value: w.id
                        }))
                    ];
                    setWarehouselist(warehouseOptions);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const [counts, setCounts] = useState({});

    let checkUlds = [];
    let filterForCheck = false;
    let boolSelectAll = 0;
    const [vehicleView, setVehicleView] = useState({});
    useEffect(() => {
        const orderTypeTab = localStorage.getItem("slotOrderTypeTab");
        // 
        if (orderTypeTab) {
            (async () => {
                await handleTabChange(orderTypeTab);
            })();
        }
    }, []);

    useEffect(() => {
        let stationData = JSON.parse(localStorage.getItem('Handler_stn'));
        // const orderType = localStorage.getItem('spl_lu');
        if (order_type && gridRefs[activeTab]?.current) {
            let tabType = '';
            let orderType = '';
            switch (activeTab) {
                case 'Loading':
                    tabType = 'A';
                    orderType = activeTab;
                    break;
                case 'Unloading':
                    tabType = 'A';
                    orderType = activeTab;
                    break;
                case 'Archived':
                    tabType = 'I';
                    orderType = 'All';
                    break;
                default:
                    tabType = 'All';
                    orderType = activeTab;
                    break;
            }
            // var token = "Bearer " + (localStorage.RFS || localStorage.Trucking || localStorage.airlinetoken || '');
            jqxCookieCall();

            const source = {
                // url: `${process.env.REACT_APP_RFS_URL}monitor/order-view-list?tab_name=${orderType}&activity_status=${tabType}&station=${stationData.station_name}`, // tab_name=${orderType}&
                url: `${process.env.REACT_APP_RFS_URL}monitor/order-view-list?tab_name=${orderType}&activity_status=${tabType}&station=${stationData.station_name}`, // tab_name=${orderType}&
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                datatype: 'json',
                id: '',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'order_id', type: 'string' },
                    { name: 'order_number', type: 'string' },
                    { name: 'order_type', type: 'string' },
                    { name: 'trip_status', type: 'string' },
                    { name: 'truck_number', type: 'string' },
                    { name: 'pick_status', type: 'string' },
                    { name: 'loading_advice', type: 'string' },
                    { name: 'carrier_name', type: 'string' },
                    { name: 'trucker_name', type: 'string' },
                    { name: 'flight_number', type: 'string' },
                    { name: 'loading_station', type: 'string' },
                    { name: 'loading_name', type: 'string' },
                    { name: 'loading_location', type: 'string' },
                    { name: 'unloading_station', type: 'string' },
                    { name: 'unloading_name', type: 'string' },
                    { name: 'unloading_location', type: 'string' },
                    { name: 'loading_date_planned', type: 'string' },
                    { name: 'unloading_date_planned', type: 'string' },
                    { name: 'truck_date', type: 'date' },
                    { name: 'awb_count', type: 'string' },

                    { name: 'update', type: 'string' },
                    { name: 'docs', type: 'string' },
                    { name: 'eta_truck', type: 'string' },
                    { name: 'station', type: 'string' },
                    { name: 'warehouse', type: 'string' },
                    { name: 'warehouse_id', type: 'string' },
                    { name: 'planned_time', type: 'string' },
                    { name: 'driver_name', type: 'string' },
                    { name: 'driver_name1', type: 'string' },
                    { name: 'driver_name2', type: 'string' },
                    { name: 'vehicle_id', type: 'string' },
                    { name: 'get_in', type: 'string' },
                    { name: 'get_out', type: 'string' },
                    { name: 'is_delay', type: 'string' },
                    { name: 'office_in', type: 'string' },
                    { name: 'office_out', type: 'string' },
                    { name: 'shipment_type', type: 'string' },
                    { name: 'mail_status', type: 'string' },

                ],
                // localdata: gridData,
                filter: function (allfilters) {
                    window.$(gridRefs[activeTab]?.current).jqxGrid('clearselection');
                    setGridSelect([]);

                    const filterInfo = window.$(gridRefs[activeTab]?.current).jqxGrid('getfilterinformation');
                    if (allfilters?.length > 0) {

                        setFilterApplied(true);
                        filterForCheck = true;

                        // const savedFilters = filterInfo.map(f => ({
                        //     datafield: f.datafield,
                        //     filter: f.filter,
                        // }));
                        const savedFilters = filterInfo.map(f => {
                            const filters = f.filter?.getfilters();
                            return {
                                datafield: f.datafield,
                                filters: filters.map(fl => ({
                                    condition: fl.condition,
                                    operator: fl.operator,
                                    value: fl.value, // this is the actual text/value typed by user                             
                                })),
                            }
                        });

                        localStorage.setItem('ovFilter', JSON.stringify(savedFilters))
                    } else {

                        setFilterApplied(false);
                        filterForCheck = false;
                        localStorage.setItem('ovFilter', []);
                        localStorage.setItem('slotOrderTypeTab', "")
                    }
                    window.$(gridRefs[activeTab]?.current).jqxGrid("updatebounddata", "filter");
                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;
                    setCounts({ open: data?.open_count, process: data.processing_count, completed: data.completed_count })
                },
                sort: function () {
                    window.$(gridRefs[activeTab]?.current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };

            const dataAdapter = new window.$.jqx.dataAdapter(source);
            // let columns = [];

            const columns = [
                {
                    text: '', datafield: '', width: '2%', filterable: false,
                    cellsrenderer: function () {
                        return '<div class="jqx-grid-cell-left-align order_detils"><img src="' + Showdetails + '"/> </div>';
                    },
                },
                { text: 'Truck No.', datafield: 'truck_number', width: '6%' },
                {
                    text: 'Truck Date', datafield: 'truck_date', width: '7%', filtertype: 'range', cellsformat: 'dd-MM-yyyy', filtermode: 'range',
                    // cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                    //     if (!cellValue) return "";
                    //     const dateObj = new Date(cellValue + 'Z');
                    //     const formattedDate = dateObj.toISOString().slice(0, 16).replace("T", " ");
                    //     return '<div class="jqx-grid-cell-left-align set_datetime" id=' + dataField + '>' + formattedDate + '</div>';
                    // },
                },
                ...( // Add this column only if the condition is met
                    !user
                        // ? [{ text: 'Carrier Name', datafield: 'carrier_name', width: '7%' }]
                        ? [{ text: 'Trucker Name', datafield: 'trucker_name', width: '7%' }]
                        : [{ text: 'Trucker Name', datafield: 'trucker_name', width: '7%' }]
                ),
                {
                    text: 'Order', datafield: 'loading_advice', width: '4%', filterable: false,
                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                        if (cellValue) { //  + process.env.REACT_APP_BASE_URL_IMAGE + 'TruckMonitor/'
                            defaultHtml = "<div style='line-height: 38px;'><a target='_blank' href=' " + cellValue + " '>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>";
                        }
                        return (
                            defaultHtml
                        );
                    },
                },
                {
                    text: 'Mail', datafield: 'mail_status', width: '4%', filterable: false,
                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                        if (data.order_type === 'Loading') {
                            if (cellValue == 0) {
                                defaultHtml = "<div style='line-height: 38px;'><img class='confirmEmailModal' src='" + Mailred + "'/></div>";
                            } else {
                                defaultHtml = "<div style='line-height: 38px;'><img src='" + MailGreen + "'/></div>";
                            }
                        } else {
                            defaultHtml = "";
                        }
                        return defaultHtml;
                    },
                },
                { text: 'AWB/ULD', datafield: 'awb_count', width: '5%', cellclassname: 'awb_gap' },
                { text: 'Planned Time', datafield: 'planned_time', filtertype: 'range', filtermode: 'range', cellsformat: 'dd-MM-yyyy', width: '8%' },
                {
                    text: 'Import/Export', datafield: 'shipment_type', width: '6%', filtertype: 'checkedlist',
                    filteritems: [
                        { label: 'Import', value: 'Import' },
                        { label: 'Export', value: 'Export' },
                    ],
                },
                {
                    text: 'Update', datafield: 'update', width: '6%', filterable: false,
                    cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, data) {
                        // 
                        if (data.order_type === 'Loading') {
                            return '<div class="set_fn"> <img src="' + pen + '" class="row_edit" /> Set </div>';
                        } else {
                            return ''
                        }
                    },
                },
                {
                    text: 'Docs', datafield: 'docs', width: '5%', filtertype: 'checkedlist',
                    filteritems: [
                        { label: 'Open', value: 'Open' },
                        { label: 'Processing', value: 'Processing' },
                        { label: 'Completed', value: 'Completed' },
                        // { label: 'Incomplete', value: 'Incomplete' },
                    ],
                },
                {
                    text: 'Pickup Status', datafield: 'pick_status', width: '10%', filterable: false,
                    cellsrenderer: (row, columnfield, value, defaulthtml, columnproperties) => {
                        if (value && Array.isArray(value)) {
                            // Generate multiple divs for each item in the array
                            const content = value
                                .map((item) =>
                                    `<div class="${item.color_status || ''}">${item.status || ''}</div>`
                                ).join(''); // Combine all divs into a single string

                            return `<div class="stats_view">${content}</div>`;
                        }
                        // Fallback if value is not an array or empty
                        return defaulthtml;
                    }
                },
                {
                    text: 'Time Stamps', filtertype: 'checkedlist', datafield: 'trip_status', width: '5%', filterable: false,
                    filteritems: [
                        { label: 'Planned', value: 'Planned' },
                        { label: 'Scheduled', value: 'Scheduled' },
                    ],

                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                        if (cellValue === 'Planned') {
                            return '<div class="jqx-grid-cell-left-align edit_sch grid_icon_left"><img src="' + Planned + '"/>  </div>';
                        } else if (cellValue === 'Scheduled') {
                            return '<div class="jqx-grid-cell-left-align edit_sch grid_icon_left"> <img src="' + Schdule + '"/>  </div>';
                        } else {
                            return '';
                        }
                    },
                },
                {
                    text: 'Delay', datafield: 'is_delay', width: '4%',
                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                        // return '<div class="jqx-grid-cell-left-align delay_click"  style="line-height: 38px;"> Delay </div>';
                        if (data.is_delay == 0) {
                            return "<img class='jqx-grid-cell-left-align delay_click' style='width: 25px;margin-top: 8px;margin-left: 14px;' src='" + DelayD + "'/>";
                        } else {
                            return "<img class='jqx-grid-cell-left-align delay_click' style='width: 25px;margin-top: 8px;margin-left: 14px;' src='" + DelayA + "'/>";
                        }
                    },
                },
                // { text: 'Office In', datafield: 'office_in', width: '7%' },
                // { text: 'Office Out', datafield: 'office_out', width: '7%' },

                // {
                //     text: 'Office In',
                //     datafield: 'office_in',
                //     width: '5%',
                //     cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                //         if (cellValue) {
                //             return '<div style="margin-top:12px; margin-left:10px"><img src="' + OfficeIn + '"/></div>';
                //         } else {
                //             // return '<div style="margin-top:12px;margin-left:10px"><img src="' + OfficeOut + '"/></div>';
                //         }
                //     },
                // },
                // {
                //     text: 'Office Out',
                //     datafield: 'office_out',
                //     width: '5%',
                //     cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                //         if (cellValue) {
                //             return '<div style="margin-top:12px;margin-left:10px"><img src="' + OfficeIn + '"/></div>';
                //         } else {
                //             // return '<div style="margin-top:12px;margin-left:10px"><img src="' + OfficeOut + '"/></div>';
                //         }
                //     },
                // },


                // { text: 'ETA Truck', datafield: 'eta_truck', width: '7%' },
                { text: 'Station', datafield: 'station', width: '4%' },
                { text: 'Warehouse', datafield: 'warehouse', width: '6%', },
                {
                    text: 'Order Type', datafield: 'order_type', width: '7%', filtertype: 'checkedlist',
                    filteritems: [
                        { label: 'Loading', value: 'Loading' },
                        { label: 'Unloading', value: 'Unloading' },
                    ],

                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                        if (cellValue === 'Loading') {
                            return '<div class="m_loading"> <img src="' + Loading + '"/> ' + cellValue + ' </div>';
                        } else if (cellValue === 'Unloading') {
                            return '<div class="m_unloading"><img src="' + Unloading + '"/> ' + cellValue + ' </div>';
                        } else {
                            return '';
                        }
                    },
                },
                {
                    text: 'Order No.', datafield: 'order_number', width: '8%',
                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                        if (cellValue) {
                            return '<div class="jqx-grid-cell-left-align order_detils"> ' + cellValue + ' </div>';
                        }
                    },
                },
                { text: 'Vehicle ID', datafield: 'vehicle_id', width: '7%' },
                // { text: 'Driver Name', datafield: 'driver_name', width: '7%' },


                // { text: 'Carrier Name', datafield: 'carrier_name', width: '9%' },

                // { text: 'Flight No.', datafield: 'flight_number', width: '8%' },
                // { text: 'Loading Date', cellsformat: 'dd-MM-yyyy', datafield: 'loading_date_planned', width: '9%' },
                // { text: 'Loading Station', datafield: 'loading_station', width: '6%' },
                // { text: 'Loading Location', datafield: 'loading_name', width: '9%' },
                // { text: 'Unloading Date', cellsformat: 'dd-MM-yyyy', datafield: 'unloading_date_planned', width: '9%' },
                // { text: 'Unloading Station', datafield: 'unloading_station', width: '7%' },
                // { text: 'Unloading Location', datafield: 'unloading_name', width: '10%' },
            ];
            // Important
            // if (activeTab === 'All') {
            //     columns.splice(8, 0, {
            //         text: 'Order Type', filtertype: 'checkedlist', datafield: 'order_type', width: '9%',
            //         filteritems: [
            //             { label: 'Loading', value: 'Loading' },
            //             { label: 'Unloading', value: 'Unloading' },
            //         ],

            //         cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
            //             if (cellValue === 'Loading') {
            //                 return '<div class="m_loading"> <img src="' + Loading + '"/> ' + cellValue + ' </div>';
            //             } else if (cellValue === 'Unloading') {
            //                 return '<div class="m_unloading"><img src="' + Unloading + '"/> ' + cellValue + ' </div>';
            //             } else {
            //                 return '';
            //             }
            //         },
            //     });
            // }

            // Nested ULD Start
            const nestedColumns = [
                { text: 'Airway Bill', datafield: 'airway_bill', width: '8%' },
                { text: 'Import/Export', datafield: 'shipment_type', width: '6%' },
                // {
                //     text: 'Order Type', datafield: 'order_type', width: '8%',

                //     cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                //         if (cellValue === 'Loading') {
                //             return '<div class="m_loading"> <img src="' + Loading + '"/> ' + cellValue + ' </div>';
                //         } else if (cellValue === 'Unloading') {
                //             return '<div class="m_unloading"><img src="' + Unloading + '"/> ' + cellValue + ' </div>';
                //         } else {
                //             return '';
                //         }
                //     },
                // },
                {
                    text: 'Pickup Status', datafield: 'pick_status', width: '10%',
                    cellsrenderer: (row, columnfield, value, defaulthtml, columnproperties) => {
                        if (value && Array.isArray(value)) {
                            // Generate multiple divs for each item in the array
                            const content = value
                                .map((item) =>
                                    `<div class="${item.color_status || ''}">${item.status || ''}</div>`
                                ).join(''); // Combine all divs into a single string

                            return `<div class="stats_view">${content}</div>`;
                        }
                        // Fallback if value is not an array or empty
                        return defaulthtml;
                    }
                },
                { text: 'Pcs', datafield: 'pieces', width: '5%' },
                { text: 'RCF', datafield: 'rcf', width: '5%' },
                { text: 'MAN', datafield: 'man', width: '5%' },

                { text: 'MSCA', datafield: 'msca', width: '5%' },
                { text: 'Package', datafield: 'package', width: '8%' },
                { text: 'ULD No.', datafield: 'uld_number', width: '8%' },
                { text: 'Weight', datafield: 'weight', width: '8%' },
                { text: 'Volume', datafield: 'volume', width: '8%' },
                { text: 'LM', datafield: 'lm', width: '8%' },
                { text: 'Nature of Goods', datafield: 'nature_of_goods', width: '8%' },

            ];
            const nestedGrids = {};
            const initrowdetails = (index, parentElement, gridElement, record) => {
                const nestedGridContainer = parentElement.children[0];
                // 

                const parentRowId = record.uid.toString();
                nestedGrids[parentRowId] = nestedGridContainer;

                parentElement.addEventListener('click', (event) => {
                    const target = event.target;
                    // Check if the click target is the nested arrow
                    if (window.$(target).hasClass('jqx-icon-arrow-right')) {
                        // Handle nested arrow click here
                        // 
                        event.stopPropagation(); // Prevent event bubbling to the row details
                    }
                });

                const id = record.uid.toString();

                const uldGrid = dataAdapter.loadedData.Rows[id].awb;

                const nestedSource = {
                    datatype: 'json',
                    id: 'shipmentChildID',
                    datafields: [
                        { name: 'id', type: 'string' },
                        { name: 'airway_bill', type: 'string' },
                        { name: 'pick_status', type: 'string' },
                        { name: 'pieces', type: 'string' },
                        { name: 'rcf', type: 'string' },
                        { name: 'man', type: 'string' },
                        { name: 'msca', type: 'string' },
                        { name: 'package', type: 'string' },
                        { name: 'uld_number', type: 'string' },
                        { name: 'weight', type: 'string' },
                        { name: 'volume', type: 'string' },
                        { name: 'lm', type: 'string' },
                        { name: 'nature_of_goods', type: 'string' },
                        { name: 'order_type', type: 'string' },
                        { name: 'shipment_type', type: 'string' },
                    ],
                    localdata: uldGrid,
                }

                const nestedDataAdapter = new window.$.jqx.dataAdapter(nestedSource);

                const nestedGridOptions = {
                    width: '100%',
                    pageable: false,
                    sortable: false,
                    // pageSize: 15,
                    autoheight: false,
                    height: (10 * 45),
                    selectionmode: '', // checkbox
                    source: nestedDataAdapter,
                    filterable: false,
                    columns: nestedColumns,
                    rowdetails: false,
                    rowsheight: 45,
                    showemptyrow: false,
                    ready: function () {
                        // Manually set row IDs starting from 0
                        const rows = window.$(nestedGridContainer).jqxGrid('getrows');
                        for (let i = 0; i < rows.length; i++) {
                            const rowid = i; // Use index as the new row ID
                            const row = rows[i];
                            window.$(nestedGridContainer).jqxGrid('setcellvalue', row.uid, 'uid', rowid);
                            window.$(nestedGridContainer).jqxGrid('updaterow', rowid, row);
                            window.$(nestedGridContainer).find(`[role="row"][row-id="${row.uid}"]`).attr('row-id', rowid);
                        }
                    },
                };
                window.$(nestedGridContainer).jqxGrid(nestedGridOptions);


            };
            // Nested End

            // const gridOptions = {
            //     width: '100%',
            //     source: dataAdapter,
            //     columns: columns,
            //     autoheight: false,
            //     height: 1040,
            //     sortable: true,
            //     altrows: false,
            //     enabletooltips: false,
            //     editable: false,
            //     selectionmode: 'checkbox', // checkbox 

            //     initrowdetails: initrowdetails,
            //     pageable: true,
            //     pageSize: 50,
            //     pagesizeoptions: ['50', '100', '200', '500'],
            //     pagerButtonsCount: 5,
            //     pagerMode: 'advanced',
            //     filterable: true,
            //     filterrowheight: 45,
            //     showfilterrow: true,
            //     rowsheight: 42,
            //     columnsheight: 45,
            //     virtualmode: true,
            //     rendergridrows: function (params) {
            //         return params.data;
            //     },
            //     rowdetails: true,
            //     rowdetailstemplate: {
            //         rowdetails: '<div id="nestedGrid" style="margin: 10px;"></div>',
            //         rowdetailsheight: (10 * 45),
            //         rowdetailshidden: true,
            //     },
            //     ready: function () {
            //         // window.$(gridRefs[activeTab]?.current).on('pagechanged', function (event) {
            //         //     boolSelectAll = 0;
            //         //     setTimeout(() => {
            //         //         const grid = window.$(gridRefs[activeTab]?.current);
            //         //         if (!grid) return;
            //         //         grid.jqxGrid('clearselection');
            //         //         const rows = grid.jqxGrid('getrows');
            //         //         rows.forEach((element) => {
            //         //             const boundIndex = grid.jqxGrid('getrowboundindex', element.uid);
            //         //             if (checkUlds.includes(element.order_id)) {
            //         //                 grid.jqxGrid('selectrow', boundIndex);
            //         //                 
            //         //             } else {
            //         //                 grid.jqxGrid('unselectrow', boundIndex);
            //         //                 
            //         //             }
            //         //         });
            //         //     }, 3000);
            //         // });

            //         window.$(gridRefs[activeTab]?.current).on('pagechanged', function (event) {
            //             boolSelectAll = 0;
            //             const grid = window.$(gridRefs[activeTab]?.current);
            //             if (!grid || !grid.jqxGrid) return;

            //             // Use the 'bindingcomplete' event which fires when grid data is loaded
            //             grid.on('bindingcomplete', function () {
            //                 grid.jqxGrid('clearselection');
            //                 const rows = grid.jqxGrid('getrows');
            //                 rows.forEach((element) => {
            //                     const boundIndex = grid.jqxGrid('getrowboundindex', element.uid);
            //                     if (checkUlds.includes(element.order_id)) {
            //                         grid.jqxGrid('selectrow', boundIndex);
            //                         
            //                     } else {
            //                         grid.jqxGrid('unselectrow', boundIndex);
            //                         
            //                     }
            //                 });

            //                 // Unbind the event to prevent multiple bindings
            //                 grid.off('bindingcomplete');
            //             });
            //         });
            //         localStorgeFilter();
            //     },
            // };
            // NOTE : the above has the nested error , have checked autoheight,virtualmode,specific height but the error is not beacuse of any of those , if you figure out kindly delete the comment and state the soln here 
            const gridOptions = {
                width: "100%",
                source: dataAdapter,
                columns: columns,
                selectionmode: 'checkbox',
                autoheight: false,
                height: 1040,
                virtualmode: true,
                sortable: true,
                altrows: false,
                enabletooltips: true,
                editable: false,
                initrowdetails: initrowdetails,
                pageable: true,
                pageSize: 20,
                pagesizeoptions: ["20", "50", "100", "200", "500"],
                pagerButtonsCount: 5,
                pagerMode: "advanced",
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                rowdetails: true,
                rowdetailstemplate: {
                    rowdetails: '<div id="nestedGrid" style="margin: 10px;"></div>',
                    rowdetailsheight: 10 * 45,
                    rowdetailshidden: true,
                },
                rendergridrows: function (params) {
                    return params.data;
                },
            };

            window.$(gridRefs[activeTab]?.current).jqxGrid(gridOptions);
            window.$(gridRefs[activeTab]?.current).find('.jqx-grid-column-header').css('background-color', 'white');

            window.$(gridRefs[activeTab].current).on('click', '.set_fn', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);

                const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);

                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                    // 
                    const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
                    if (rowData) {
                        const rId = rowData.uid
                        const nestedData = dataAdapter.loadedData.Rows[rId].awb;
                        const transformData = { ...rowData, nestedData }
                        loadDetails(rowData.order_id, 'S')
                        // setModalData(transformData);
                        // setStatusData(nestedData);
                        setEditModa(false)
                    } else {
                        console.error('No data found for the given row index.');
                    }
                } else {
                    console.error('Bound index could not be retrieved. Check the row index and data binding.');
                }

                // setIsModal(true);

            });

            window.$(gridRefs[activeTab].current).on('click', '.edit_sch', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);

                const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);

                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                    // 
                    const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
                    if (rowData) {
                        setVehicleView({
                            'vehicle_id': rowData.vehicle_id,
                            'order_number': rowData.order_number
                        });
                        const rId = rowData.uid
                        const nestedData = dataAdapter.loadedData.Rows[rId].awb;
                        const transformData = { ...rowData, nestedData }
                        // loadDetails(rowData.order_id, 'S')
                        // setModalData(transformData);
                        setTimeData(nestedData);
                        setSchdlModalData('SCH')
                        monitor_order_vehicle(dataAdapter.loadedData.Rows[rId].order_id);
                        const selectedScheduleDataassign = {
                            'order_id': dataAdapter.loadedData.Rows[rId].order_id,
                            'order_type': dataAdapter.loadedData.Rows[rId].order_type,
                        };
                        setSchdlModal(true)
                        setSelectedScheduleData(selectedScheduleDataassign);
                        setChangedData(prev => ({
                            ...prev,
                            officeIn: dataAdapter.loadedData.Rows[rId].office_in,
                            officeOut: dataAdapter.loadedData.Rows[rId].office_out,
                            startLoading: dataAdapter.loadedData.Rows[rId].start_time,
                            endLoading: dataAdapter.loadedData.Rows[rId].end_time,
                            // officeIn: dataAdapter.loadedData.Rows[rId].office_in || new Date().toISOString().slice(0, 16),
                            // officeOut: dataAdapter.loadedData.Rows[rId].office_out || new Date().toISOString().slice(0, 16),
                            // startLoading: dataAdapter.loadedData.Rows[rId].start_time || new Date().toISOString().slice(0, 16),
                            // endLoading: dataAdapter.loadedData.Rows[rId].end_time || new Date().toISOString().slice(0, 16),
                            gateIn: rowData.get_in,
                            gateOut: rowData.get_out,
                            driver_name1: rowData.driver_name1,
                            driver_name2: rowData.driver_name2,

                        }));

                    } else {
                        console.error('No data found for the given row index.');
                    }
                } else {
                    console.error('Bound index could not be retrieved. Check the row index and data binding.');
                }

                // setIsModal(true);

            });
            window.$(gridRefs[activeTab].current).on('click', '.confirmEmailModal', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);

                const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);

                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                    // 
                    const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
                    if (rowData) {
                        const rId = rowData.uid
                        const nestedData = dataAdapter.loadedData.Rows[rId].awb;
                        const transformData = { ...rowData, nestedData };
                        //warehouse_id
                        setConfirmFormData(prev => ({
                            ...prev,
                            warehouse_list: transformData.warehouse_id
                        }));
                        // setConfirmEmailModal(true);
                        loadDetails(rowData.order_id, 'P')

                    } else {
                        console.error('No data found for the given row index.');
                    }
                } else {
                    console.error('Bound index could not be retrieved. Check the row index and data binding.');
                }

            });
            window.$(gridRefs[activeTab].current).on('click', '.delay_click', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);

                const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);

                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                    // 
                    const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
                    if (rowData) {
                        const rId = rowData.uid
                        const nestedData = dataAdapter.loadedData.Rows[rId].awb;
                        const transformData = { ...rowData, nestedData }
                        // loadDetails(rowData.order_id, 'S')
                        // setModalData(transformData);
                        setTimeData(nestedData);
                        setSchdlModalData('DEL')
                        monitor_order_vehicle(dataAdapter.loadedData.Rows[rId].order_id);
                        const selectedScheduleDataassign = {
                            'order_id': dataAdapter.loadedData.Rows[rId].order_id,
                            'order_type': dataAdapter.loadedData.Rows[rId].order_type,
                        };
                        setSchdlModal(true)
                        setSelectedScheduleData(selectedScheduleDataassign);
                        setChangedData(prev => ({
                            ...prev,
                            officeIn: dataAdapter.loadedData.Rows[rId].office_in,
                            officeOut: dataAdapter.loadedData.Rows[rId].office_out,
                            startLoading: dataAdapter.loadedData.Rows[rId].start_time,
                            endLoading: dataAdapter.loadedData.Rows[rId].end_time,
                            gateIn: rowData.get_in,
                            gateOut: rowData.get_out
                        }));

                    } else {
                        console.error('No data found for the given row index.');
                    }
                } else {
                    console.error('Bound index could not be retrieved. Check the row index and data binding.');
                }

                // setIsModal(true);

            });

            window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const selectedRowId = selectedRow.uid;
                    const uldNumber = selectedRow.order_id;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }
                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.order_id === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (boolSelectAll == 0 || checkUlds.length == 0) {
                        checkUlds = [];
                        setGridSelect([]);
                        const selectedIndexes = window.$(gridRefs[activeTab].current).jqxGrid('getselectedrowindexes');
                        let selectedRows = [];

                        selectedIndexes.forEach(index => {
                            const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', index);
                            if (rowData && rowData.order_id) {
                                checkUlds.push(rowData.order_id);
                                selectedRows.push(rowData);
                            }
                        });
                        setGridSelect(prevGridSelect => {
                            // Merge existing selections with new ones, avoiding duplicates
                            const newSelections = selectedRows.filter(
                                row => !prevGridSelect.some(existing => existing.order_id === row.order_id)
                            );
                            return [...prevGridSelect, ...newSelections];
                        });
                        boolSelectAll = 1;
                    } else {

                        checkUlds = [];
                        boolSelectAll = 0;
                        setGridSelect([]);
                    }

                }
            });
            window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.order_id;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.order_id !== unselectedRowId));
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                }
            });
            window.$(gridRefs[activeTab]?.current).off('cellclick');
            window.$(gridRefs[activeTab]?.current).on('cellclick', (event) => {
                const args = event.args.row.bounddata;

                // if (event.args.columnindex === 3 && event.args.columnindex === 7) {
                //     return;
                // }
                if (event.args.columnindex === 2) {
                    // 
                    localStorage.setItem('OVDetails', JSON.stringify(args.order_id));
                    // window.location.href = '/HandlerTruckMonitor/OrdersViewDetails'
                    onDetails()
                }
                if (event.args.columnindex !== 0 && event.args.columnindex !== 6 && event.args.columnindex !== 7 && event.args.columnindex !== 11 && event.args.columnindex !== 14 && event.args.columnindex !== 15) {

                    if (gridSelect) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs[activeTab]?.current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                        // setGridSelect([]);
                    }
                    loadDetails(args.order_id);
                    // setSelectedRowData(args);
                }
            });
        }
    }, [gridData]);



    const resetFilters = () => {
        window.$(gridRefs[activeTab]?.current).jqxGrid('clearfilters');
    };
    function localStorgeFilter() {
        let savedFilters = localStorage.getItem('ovFilter');
        if (savedFilters) {
            savedFilters = JSON.parse(localStorage.getItem('ovFilter'));
            savedFilters.forEach(element => {
                const filterValue = element.filters[0].value;
                if (filterValue !== null && filterValue !== undefined) {
                    const filterGroup = new window.$.jqx.filter();
                    const filterCondition = element.filters[0].condition ?? "CONTAINS"; // Adjust the condition as needed
                    const filter = filterGroup.createfilter("stringfilter", filterValue, filterCondition);
                    filterGroup.addfilter(1, filter);
                    window.$(gridRefs[activeTab].current).jqxGrid("addfilter", element.datafield, filterGroup);
                }
            });
            window.$(gridRefs[activeTab].current).jqxGrid("applyfilters");
            setApplyFilter(false);
        }
    };

    useEffect(() => {
        if (resetGrid) {
            // window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');

            if (gridRefs[activeTab]?.current) {
                window.$(gridRefs[activeTab].current).jqxGrid('clearfilters');
                window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");
            }
        }
    }, [resetGrid])
    const loadDetails = async (id, pos) => {
        setDisLoading(true);
        try {
            const res = await withRFSToken.post(TRUCKORDERSDETAILS, { order_id: id });
            // .then(function (res) {
            if (res.data.response_code === 200) {
                const innerData = res.data.response_data;
                if (pos === 'S') {
                    setModalData(innerData);
                    setStatusData(innerData.awbs);
                    setAwbsData(innerData.awbs);
                    setIsModal(true);
                    setEditStatusIndex(false);
                    if (innerData.doc_status) {
                        setDocStatus(innerData.doc_status)
                    }
                } else if (pos === 'P') {
                    setModalData(innerData);
                    setStatusData(innerData.awbs);
                    setAwbsData(innerData.awbs);
                    setConfirmEmailModal(true);
                    setEditStatusIndex(false);
                    if (innerData.doc_status) {
                        setDocStatus(innerData.doc_status)
                    }
                } else {
                    setSelectedRowData(innerData);
                    setMrnCrm({ mrn: innerData?.mrn || '', crm: innerData?.crm || '' })
                    setEditMrnCrm('')
                }
                setDisLoading(false);
            } else {
                toast.error('No Details found');
                setDisLoading(false);
            }

            // });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const OrderViewDetailsClick = () => {
        try {
            // Check if selectedRowData is defined
            if (!selectedRowData) {
                throw new Error('Selected row data is not available.');
            }

            localStorage.removeItem('OVDetails');
            const storageData = {
                ULD: selectedRowData,  // ULD Details section
                Form: {}  // Empty form section
            };
            localStorage.setItem('OVDetails', JSON.stringify(selectedRowData.order_id));
            // localStorage.setItem('tab', 'assets');
            // window.location.href = '/HandlerTruckMonitor/OrdersViewDetails'
            onDetails()
        } catch (error) {
            // Log the error for debugging purposes
            console.error('Error during navigation:', error.message);
            alert('An error occurred: ' + error.message); // Optional user alert
        }
    }

    const [showConfirmation, setShowConfirmation] = useState(false);

    const handleDropdownItemClick = () => {
        if (gridSelect.length > 0) {
            setShowConfirmation(true);
        } else {
            toast.error('Please select at least one row');
        }
    }

    const handleRemove = (indexToRemove) => {

        setGridSelect(prev => prev.filter(row => row.order_id !== indexToRemove));
        const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
        rows.forEach((element, index) => {
            if (element.order_id == indexToRemove) {
                window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', index);
            }
        });
    };

    const closeConf = () => {
        setShowConfirmation(false);
        gridSelect.forEach(item => {
            const selectedRowBoundIndex = item.boundindex;
            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
        });
        window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata");
    }

    const handleConfirmChange = async () => {
        if (gridSelect.length > 0) {
            const ids = gridSelect.map(id => id.order_id).join(',\n');

            const payload = { order_ids: gridSelect.order_id, doc_status: 'docStatus' }
            // window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata");
            window.open(`${process.env.REACT_APP_RFS_URL}ganarate-loading-advice?order_ids=${ids}`, '_blank');
            const timer = setTimeout(() => {
                closeConf();
                // setMessage('Timeout triggered!');
            }, 2000);
            // setShowConfirmation(false);


            // try {
            //     const res = await withRFSToken.get(`ganarate-loading-advice?order_ids=${ids}`,)
            //         .then(function (res) {
            //             const innerData = res;
            //             setShowConfirmation(false);
            //             window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata");
            //             window.location.href = ``
            //             // if (res.data.response_code == 200) {
            //             //     // setSelectedRowData(res.data.response_data);
            //             //     toast.success(res.data.response_msg);
            //             //     setShowConfirmation(false);
            //             //     window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata");
            //             // } else if (res.data.response_code == 400) {
            //             //     toast.warning(res.data.response_msg)
            //             // } else {
            //             //     toast.error(res.data.response_msg)
            //             // }
            //         });
            // } catch (error) {
            //     console.error('Error sending request:', error);
            // }
        } else { toast.error('Please select at least one Order') }

    }

    const handleCloseClick = () => {
        setSelectedRowData(null);
        window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata");
    };

    // FILE UPLOAD START
    const [showModalUpload, setShowModalUpload] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);
    const [base64Files, setBase64Files] = useState([]);

    // const imageModalUpload = (id) => {
    //     setSelectedRowId(id);
    //     setShowModalUpload(true)
    //     setFiles([])
    // }

    const imageModalUpload = (id) => {
        const selectedRowFiles = gridSelect.find(item => item.uid === id)?.files || [];
        setFiles(selectedRowFiles);
        setSelectedRowId(id); // Store the ID of the selected row
        setShowModalUpload(true);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        getBase64(droppedFiles[0]);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index) => {
        setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
        base64Files.splice(index, 1);
    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {

        };
    }
    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const filesWithBase64 = [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                // filesWithBase64.push({ file, base64: reader.result });
                filesWithBase64.push({ "base64": reader.result, "file_name": file.name });
                if (filesWithBase64.length === selectedFiles.length) {
                    // setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => obj.file)]);
                    // setBase64Files((prevBase64Files) => [...prevBase64Files, ...filesWithBase64.map((obj) => obj.base64)]);
                    setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
                    setBase64Files((prevBase64Files) => [...prevBase64Files, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const imageUpload = () => {
        setGridSelect(prevGridSelect =>
            prevGridSelect.map(item => {
                if (item.uid === selectedRowId) {
                    return { ...item, files: files, base64Files: base64Files };
                }
                return item;
            })
        );
        setShowModalUpload(false);
    };
    // upload forward
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };
    // FILE UPLOAD END

    const [docStatus, setDocStatus] = useState('O');
    const [editModa, setEditModa] = useState(false);
    const closeModal = () => {
        setIsModal(false);
        setDocStatus('O');
        setEditStatusIndex(false);
    };

    // Handle radio button change
    const handleRadioChange = (e) => {
        if (docStatus == 'C') {
            if (e.target.value == 'O' || e.target.value == 'P') {
                const updatedStatusData = awbsData.map(item => ({
                    ...item,
                    pick_status: [
                        { status: "rcf", color_status: "rcf_class" }
                    ],
                    man: '',
                }));
                setStatusData(updatedStatusData);
            }
        }
        setDocStatus(e.target.value);
        if (e.target.value === 'C') {
            const updatedStatusData = awbsData.map(item => ({
                ...item,
                pick_status: [
                    // ...item.pick_status,
                    { status: "rfp", color_status: "rfp_class" }
                ],
                man: Number(item.pieces),
                rcf: item.rcf
            }));
            setStatusData(updatedStatusData);
        } else {

            if (docStatus !== 'C') {
                const allRfp = awbsData.every(item => item?.pick_status?.[0]?.status === "rfp");
                if (allRfp) {

                } else {
                    const updatedStatusData = awbsData.map(item => ({
                        ...item,
                        pick_status: item.pick_status,
                        man: item.man == null ? '' : item.man,
                        rcf: item.rcf
                    }));
                    setStatusData(updatedStatusData);
                }
            }
        }
        setEditStatusIndex(false);
    };


    // Handle enabling editing for a row
    const handleEditRow = (index) => {
        setEditStatusIndex(index);
    };
    const handleEditCompleteRow = () => {
        setEditStatusIndex(false);
    };

    // Handle field value changes
    const handleFieldChange = (index, field, value) => {
        const updatedData = structuredClone(statusData)// [...statusData];
        // const numericValue = value == '' ? null : value == '0' ? null : Number(value)
        const numericValue = value == '' ? null : Number(value)
        updatedData[index][field] = numericValue;
        setStatusData(updatedData);
        // if (docStatus == 'P') {
        //     const pieces = Number(updatedData[index].pieces);
        //     if (field == 'man') {
        //         if (numericValue == pieces) {

        //             updatedData[index].pick_status = [
        //                 // ...updatedData[index].pick_status,
        //                 { status: "rfp", color_status: "rfp_class" }
        //             ];
        //             setDocStatus('C')
        //         } else if (numericValue < pieces) {
        //             

        //             updatedData[index].pick_status = [
        //                 ...updatedData[index].pick_status,
        //                 // { status: "rfp", color_status: "rfp_class" }
        //             ];
        //             setDocStatus('P')
        //         }
        //     }
        // }
        if (docStatus == 'C' || docStatus == 'O' || docStatus == 'P') {
            const pieces = Number(updatedData[index].pieces);
            const man = updatedData[index].man;
            const rcf = updatedData[index].rcf;
            if (field == 'man') {
                if (statusData.length === 1) { setDocStatus('C') }
                if (numericValue < pieces) {
                    updatedData[index].pick_status = [
                        // ...updatedData[index].pick_status,
                        { status: "rfp", color_status: "rfp_class" },
                        { status: "msca", color_status: "msca_class" }
                    ];
                    // setDocStatus('P')
                } else if (numericValue >= pieces) {

                    updatedData[index].pick_status = [
                        // ...updatedData[index].pick_status,
                        { status: "rfp", color_status: "rfp_class" }
                    ];
                }

                if (numericValue == null) {
                    if (!statusData[index].rcf || statusData[index].rcf == '') {
                        updatedData[index].pick_status = [];
                    } else if (pieces == statusData[index].rcf) {
                        updatedData[index].pick_status = [
                            { status: "rcf", color_status: "rcf_class" }
                        ];
                    } else if (pieces > statusData[index].rcf) {
                        updatedData[index].pick_status = [
                            { status: "rcf", color_status: "rcf_class" },
                            { status: "msca", color_status: "msca_class" }
                        ];
                    }
                }
                setEditModa(true);
                // 
                // const updatedStatusData = modalData.nestedData.map(item => ({
                //     ...item,
                //     pick_status: item.pick_status,
                // }));
            } else if (field == 'rcf') {

                if (numericValue <= pieces) {
                    if (statusData[index].man < pieces) {
                        updatedData[index].pick_status = [
                            { status: "rfp", color_status: "rfp_class" },
                            { status: "msca", color_status: "msca_class" }
                        ];
                    } else if (statusData[index].man == pieces) {
                        updatedData[index].pick_status = [
                            { status: "rfp", color_status: "rfp_class" }
                        ];
                    }
                }
                if (numericValue == pieces) {
                    if (!statusData[index].man || statusData[index].man == '') {
                        updatedData[index].pick_status = [
                            { status: "rcf", color_status: "rcf_class" }
                        ];
                    }
                }
                if (numericValue < pieces) {
                    if (!statusData[index].man || statusData[index].man == '') {
                        updatedData[index].pick_status = [
                            { status: "rcf", color_status: "rcf_class" },
                            { status: "msca", color_status: "msca_class" }
                        ];
                    }
                }
                if (numericValue == null) {
                    if (!statusData[index].man || statusData[index].man == '') {
                        updatedData[index].pick_status = [];
                    }
                }
            }
        }
        setStatusData([...updatedData]);
    };

    useEffect(() => {
        if (editModa) {
            if (statusData.length > 1) {
                // 
                const hasMissingMan = statusData.some(row => row.man === null || row.man === '' || row.man === undefined);
                if (hasMissingMan) {
                    setDocStatus('P');
                } else {
                    const allManValid = statusData.every(row => Number(row.man) >= 0);
                    if (allManValid) {
                        setDocStatus('C');
                    }
                }
            }
        }

    }, [statusData])

    const updateStatus = async () => {
        const updateData = statusData.map((row, index) => {

            // if (editStatusIndex === index) {
            return {
                awb_id: row.id, // Identify the row by its unique field monitor/order-doc-update
                pieces: row.pieces,
                rcf: row.rcf,
                man: row.man
            };
            // }
            // return null;
        }).filter(Boolean);
        const payload = { order_id: modalData.order_id, doc_status: docStatus, awbs: updateData }
        try {
            const res = await withRFSToken.post('monitor/order-doc-update', payload)
                .then(function (res) {
                    const innerData = res;
                    if (res.data.response_code == 200) {
                        // setSelectedRowData(res.data.response_data);
                        toast.success(res.data.response_msg);
                        setIsModal(false);
                        window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata");
                    } else if (res.data.response_code == 400) {
                        toast.warning(res.data.response_msg)
                    } else {
                        toast.error(res.data.response_msg)
                    }
                });

        } catch (error) {
            console.error('Error sending request:', error);
        }
    }

    // active archive

    const [actArcModal, setActArcModal] = useState(false);

    const handleMoveToActArc = (info) => {
        if (gridSelect.length <= 0) {
            toast.error('Please select Order first');
        } else {
            setActArcModal(true);
            setMoveToComplete(false);
        }
    };
    const confirmMoveToActArc = async () => {
        // 
        const sendAction = activeTab == 'Archived' ? 'A' : 'I';
        const ids = gridSelect?.map(data => data.order_id)
        try {
            const res = await withRFSToken.post('monitor/update-activity', { activity_status: sendAction, order_ids: ids })
                .then(function (res) {
                    if (res.data.response_code == 200) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                        setGridSelect([]);
                        window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
                        setActArcModal(false);
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const [mrnCrm, setMrnCrm] = useState({})
    const [editMrnCrm, setEditMrnCrm] = useState('')
    const handleEdtitMrnCrm = (pos) => {
        if (pos == 'mrn') {
            setMrnCrm({ mrn: selectedRowData.mrn || '' })
        } else {
            setMrnCrm({ crm: selectedRowData.crm || '' })
        }
        setEditMrnCrm(pos)
    }
    const changeMrnCrm = (e) => {


        const { name, value } = e.target;
        setMrnCrm({ [name]: value });
    }
    const updateMrnCrm = async (pos) => {
        const checkParam = mrnCrm?.mrn ? mrnCrm?.mrn != selectedRowData.mrn : mrnCrm?.crm != selectedRowData.crm
        if (checkParam) {
            const payload = { ...mrnCrm, order_id: selectedRowData.order_id }

            try {
                const res = await withRFSToken.post('monitor/update-mrn-crm', payload);
                // .then(function (res) {
                if (res.data.response_code === 200) {
                    const innerData = res.data.response_data;
                    toast.success(res.data.response_msg)
                    setMrnCrm({})
                    setEditMrnCrm('')
                    loadDetails(selectedRowData.order_id);
                } else {
                    toast.error(res.data.response_msg);
                }
                // });
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        } else {
            // toast.warning('Please change the data before update')
            setMrnCrm({})
            setEditMrnCrm('')
        }
    };

    const [selectedScheduleData, setSelectedScheduleData] = useState();
    const [changedData, setChangedData] = useState({
        officeIn: '',
        officeOut: '',
        startLoading: '',
        endLoading: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setChangedData((prev) => ({
            ...prev,
            [name]: value
        }));
    };
    const updateTime = async () => {
        const res = await withRFSToken.post('monitor/update-trip-time',
            {
                'order_id': selectedScheduleData.order_id,
                'order_type': selectedScheduleData.order_type,
                'office_in': changedData.officeIn,
                'office_out': changedData.officeOut,
                'start_time': changedData.startLoading,
                'end_time': changedData.endLoading
            }
        )
            .then(function (res) {
                if (res.data.response_code == 200) {
                    window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
                    setSchdlModal(false);
                }
            });


    };
    const confirmMoveToComplete = async () => {
        const ids = gridSelect?.map(data => data.order_id)
        try {
            const res = await withRFSToken.post('monitor/orders-doc-update', { order_ids: ids })
                .then(function (res) {
                    if (res.data.response_code == 200) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                        setGridSelect([]);
                        window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
                        setActArcModal(false);
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const handleDropdownCompleteClick = (info) => {
        if (gridSelect.length <= 0) {
            toast.error('Please select Order first');
        } else {
            setActArcModal(true);
            setMoveToComplete(true);
        }
    };


    const [orderVehicle, setOrderVehicle] = useState();
    const monitor_order_vehicle = async (orderId) => {
        try {
            const res = await withRFSToken.post('monitor/order-vehicle', { order_id: orderId })
                .then(function (res) {
                    if (res.data.response_code == 200) {
                        setOrderVehicle(res.data.response_data);
                        // setChangedData(prev => {
                        //     const response = res?.data?.response_data;
                        //     const firstItem = Array.isArray(response) && response.length > 0 ? response[0] : null;
                        //     return {
                        //         ...prev,
                        //         delay_status: firstItem?.delay_status ? JSON.parse(firstItem.delay_status) : null,
                        //         delay_remarks: firstItem?.delay_remarks ?? null,
                        //     };
                        // });
                        setChangedData(prev => {
                            const response = res?.data?.response_data;
                            const orders = {};

                            if (Array.isArray(response)) {
                                response.forEach(item => {
                                    orders[item.order_id] = {
                                        delay_status: item.delay_status ? JSON.parse(item.delay_status) : [],
                                        delay_remarks: item.delay_remarks ?? '',
                                    };
                                });
                            }

                            return {
                                ...prev,
                                orders, // <- this is the key where you store all order-wise data
                            };
                        });
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    useEffect(() => {
        // if (orderVehicle?.length === 1) {
        //     const singleOrder = orderVehicle[0]?.order_id;
        //     setChangedData((prev) => ({
        //     ...prev,
        //     order_ids: [singleOrder]
        //     }));
        // }
        if (Array.isArray(orderVehicle) && orderVehicle.length > 0) {
            const allOrderIds = orderVehicle.map(order => order.order_id);
            setChangedData((prev) => ({
                ...prev,
                order_ids: allOrderIds
            }));
        }
    }, [orderVehicle]);
    const delayOptions = [
        { value: 'Cargo did not fit', label: 'Cargo did not fit' },
        { value: 'Custom Inspection', label: 'Custom Inspection' },
        { value: 'NCTS failure', label: 'NCTS failure' },
        { value: 'Unable to locate', label: 'Unable to locate' },
        { value: 'Incorrect trailor', label: 'Incorrect trailor' },
    ];
    const updateIrregularity = async () => {
        const payload = Object.entries(changedData.orders).map(([order_id, data]) => ({
            order_id,
            delay_status: data.delay_status,
            delay_remarks: data.delay_remarks,
        }));

        const res = await withRFSToken.post('monitor/set-delay', { delay_data: payload })
            .then(function (res) {
                if (res.data.response_code == 200) {
                    window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
                    setSchdlModal(false);
                }
            });
    }
    const [selectedOrderId, setSelectedOrderId] = useState(null);
    useEffect(() => {
        if (orderVehicle?.length > 0 && selectedOrderId === null) {
            setSelectedOrderId(orderVehicle[0].order_id);
        }
    }, [orderVehicle]);
    const selectedOrder = orderVehicle?.find(
        truck => truck.order_id === selectedOrderId
    );
    const sideBarDelayClick = () => {
        setSchdlModalData('DEL')
        monitor_order_vehicle(selectedRowData.order_id);
        setSchdlModal(true)
    };

    const sideBarTripStatusClick = () => {
        setSchdlModalData('SCH')
        monitor_order_vehicle(selectedRowData.order_id);
        let order_type = "";
        if (selectedRowData.loading_edit === 1) {
            order_type = "Loading";
        } else if (selectedRowData.unloading_edit === 1) {
            order_type = "Unloading";
        }
        const selectedScheduleDataassign = {
            'order_id': selectedRowData.order_id,
            'order_type': order_type,
        };
        setSchdlModal(true)
        setSelectedScheduleData(selectedScheduleDataassign);
        setChangedData(prev => ({
            ...prev,
            officeIn: selectedRowData.loading_office_in ?? selectedRowData.unloading_office_in,
            officeOut: selectedRowData.loading_office_out ?? selectedRowData.unloading_office_out,
            startLoading: selectedRowData.loading_start ?? selectedRowData.unloading_start,
            endLoading: selectedRowData.loading_end ?? selectedRowData.unloading_end,
            gateIn: selectedRowData.get_in,
            gateOut: selectedRowData.get_out
        }));
    };

    const handleConfirmModalChange = (name, value) => {
        setConfirmFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };
    useEffect(() => {
        console.log('confirmFormData', confirmFormData);

        const availableSlotCount = async (dates) => {
            const today = new Date().toISOString().split('T')[0];
            try {
                const res = await withRFSToken.post(SLOTPLANNINGAVAILABLESLOTCOUNT, {
                    "warehouse_id": confirmFormData.warehouse_list,
                    "start_date": today,
                    "end_date": today,
                    "cargo_type_id": 3,
                    "trip_type_id": 8,
                });
                if (res.data.response_code == 200) {
                    setAllAvailableSlotCount(res.data.response_data);
                } else {
                    // toast.error(res.data.response_msg);
                }
            } catch (error) {
                console.error('Error fetching warehouse data:', error);
            }
        }
        availableSlotCount();
    }, [confirmFormData]);
    const [loaderModal, setLoaderModal] = useState(false);
    const [sendingMail, setSendingMail] = useState(false);
    const handleSaveMail = async () => {
        if (docStatus != "C") {
            toast.error("Email not send please complete rfp ");
            return false;
        }
        setSendingMail(true);
        const updateData = statusData.map((row, index) => {
            return {
                awb_id: row.id,
                pieces: row.pieces,
                rcf: row.rcf,
                man: row.man
            };
        }).filter(Boolean);
        const payload = {
            order_id: modalData.order_id,
            doc_status: docStatus,
            awbs: updateData,
            warehouse_id: confirmFormData.warehouse_list,
            door_id: allAvailableSlotCount?.[0]?.available_slots?.[0]?.door_id
        }
        try {
            const res = await withRFSToken.post('monitor/order-doc-update', payload)
                .then(function (res) {
                    const innerData = res;
                    if (res.data.response_code == 200) {
                        toast.success(res.data.response_msg);
                        setConfirmEmailModal(false);
                        window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata");
                    } else if (res.data.response_code == 400) {
                        toast.warning(res.data.response_msg)
                    } else {
                        toast.error(res.data.response_msg)
                    }
                });
        } catch (error) {
            console.error('Error sending request:', error);
        } finally {
            setSendingMail(false);
        }
    }
    return (
        <>
            <Loader isLoading={loaderModal} />
            <div className="mt-3 nestedtabs rounded minh">
                <div className='d-flex'>
                    <Dropdown>
                        <Dropdown.Toggle variant="light" id="dropdown-basic" className={gridSelect.length > 0 ? 'action grid-selected' : 'action'}>
                            <FontAwesomeIcon icon={faGear} /> Action <FontAwesomeIcon icon={faChevronDown} />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item onClick={handleDropdownItemClick}>Print Order</Dropdown.Item>
                            {activeTab !== 'All' && <Dropdown.Item onClick={() => handleMoveToActArc(activeTab === 'Archived' ? 'A' : 'R')}>{activeTab === 'Archived' ? 'Active' : 'Archive'}</Dropdown.Item>}
                            <Dropdown.Item onClick={handleDropdownCompleteClick}>Complete</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    {/* {activeTab !== 'All' &&
                        <div className='ulddown'>
                            <button onClick={() => handleMoveToActArc(activeTab === 'Archived' ? 'A' : 'R')}>
                                <img title='' src={activeTab === 'Archived' ? Activ : Arcv} /> {activeTab === 'Archived' ? 'Active' : 'Archive'}
                            </button>
                        </div>
                    } */}

                    <span className="selected">
                        Selected <Badge>{gridSelect.length}</Badge>
                    </span>

                    <div className='doc_sts'>
                        <span className="selected doc_open">
                            Open <Badge>{counts.open}</Badge>
                        </span>
                        <span className="selected doc_proses">
                            Processing <Badge>{counts.process}</Badge>
                        </span>
                        <span className="selected doc_complt">
                            Completed <Badge>{counts.completed}</Badge>
                        </span>
                    </div>

                </div>
            </div>

            <div className="maindiv">
                {disLoading &&
                    <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
                }
                <div className='trashdonload'>
                    <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="booking_tab">
                        <Tab eventKey="All" title={<span>All </span>} className='moveto'>
                            {filterApplied ? <><div className='clear_filter' style={{ left: '18px' }}><Button onClick={resetFilters}>Reset <FontAwesomeIcon icon={faRotateRight} /> </Button></div></> : <></>}
                            {/* <Loader isLoading={isLoading} /> */}
                            {!isLoading && <>
                                {/* {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>} */}
                                <div ref={gridRefs.All} className='bookinggrid' ></div>
                            </>
                            }
                            {/* <div ref={gridRefs.Active} className='bookinggrid' ></div> */}
                        </Tab>
                        <Tab eventKey="Loading" title={<span>Loading </span>} className='moveto'>
                            {filterApplied ? <><div className='clear_filter' style={{ left: '18px' }}><Button onClick={resetFilters}>Reset <FontAwesomeIcon icon={faRotateRight} /></Button></div></> : <></>}
                            {/* <Loader isLoading={isLoading} /> */}
                            {/* {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>} */}
                            {!isLoading && <div ref={gridRefs.Loading} className='bookinggrid' ></div>}
                            {/* <div ref={gridRefs.Archived} className='bookinggrid' ></div> */}
                        </Tab>
                        <Tab eventKey="Unloading" title={<span>Unloading </span>} className='moveto'>
                            {filterApplied ? <><div className='clear_filter' style={{ left: '18px' }}><Button onClick={resetFilters}>Reset <FontAwesomeIcon icon={faRotateRight} /></Button></div></> : <></>}
                            {/* <Loader isLoading={isLoading} /> */}
                            {/* {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>} */}
                            {!isLoading && <div ref={gridRefs.Unloading} className='bookinggrid' ></div>}
                            {/* <div ref={gridRefs.Archived} className='bookinggrid' ></div> */}
                        </Tab>
                        <Tab eventKey="Archived" title={<span>Archived </span>} className='moveto'>
                            {filterApplied ? <><div className='clear_filter' style={{ left: '18px' }}><Button onClick={resetFilters}>Reset <FontAwesomeIcon icon={faRotateRight} /></Button></div></> : <></>}
                            {/* <Loader isLoading={isLoading} /> */}
                            {/* {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>} */}
                            {!isLoading && <div ref={gridRefs.Archived} className='bookinggrid' ></div>}
                            {/* <div ref={gridRefs.Archived} className='bookinggrid' ></div> */}
                        </Tab>
                    </Tabs>
                    {/* {!isLoading && <div ref={gridRef} className='bookinggrid' ></div>} */}
                </div>
                {selectedRowData && (
                    <div className='SecondDiv mt-45'>
                        <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
                        <div className='girddtals_header'>
                            <h3>
                                {selectedRowData.order_number} &nbsp;
                                <span className='position-relative'>
                                    {
                                        selectedRowData?.pick_status && Array.isArray(selectedRowData?.pick_status) ?
                                            selectedRowData?.pick_status.map((item, index) =>
                                                <>
                                                    {/* <div class=""> */}
                                                    <div class={`mt-0 ${item.color_status}`} style={{ position: 'absolute', top: '1px', left: index > 0 ? '81px' : '0' }}>{item.status || ''}</div>
                                                    {/* </div> */}
                                                </>
                                            )
                                            : ''
                                    }
                                </span>
                            </h3>

                            <div className='d-flex actbtn justify-content-between'>

                                <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                                {/* <Button variant="light" onClick={OrderViewDetailsClick} > Details</Button> */}
                                <Dropdown className='me-auto'>
                                    <Dropdown.Toggle variant="link" id="dropdown-basic">
                                        <FontAwesomeIcon icon={faGear} /> Action <FontAwesomeIcon icon={faCaretDown} />
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item href="#/action-1" onClick={() => sideBarDelayClick()}>
                                            {selectedRowData.delay_status == null ? (
                                                <img
                                                    className="delay_click"
                                                    style={{ width: '18px' }}
                                                    src={DelayD}
                                                    alt="DelayD"
                                                />
                                            ) : (
                                                <img
                                                    className="delay_click"
                                                    style={{ width: '18px' }}
                                                    src={DelayA}
                                                    alt="DelayA"
                                                />
                                            )} Delay
                                        </Dropdown.Item>
                                        <Dropdown.Item href="#/action-2" onClick={() => loadDetails(selectedRowData.order_id, 'S')}>
                                            <img
                                                className=""
                                                style={{ width: '18px' }}
                                                src={Planned}
                                                alt=""
                                            /> RFP Update
                                        </Dropdown.Item>
                                        <Dropdown.Item href="#/action-3" onClick={() => sideBarTripStatusClick()}>
                                            <img
                                                className=""
                                                src={Tripimg}
                                                alt=""
                                            /> Time Stamps
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                                <div className='viwall'>
                                    <Link to='#' onClick={OrderViewDetailsClick} >View Details</Link>
                                </div>
                                {/* <Dropdown>
                                    <Dropdown.Toggle variant="light" id="dropdown-basic" >
                                        <FontAwesomeIcon icon={faBolt} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item >option</Dropdown.Item>
                                        <Dropdown.Item >option</Dropdown.Item>
                                        <Dropdown.Item >option</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown> */}

                            </div>

                        </div>
                        <div className='d-flex justify-content-between my-3'>
                            <div className='order_view'>
                                <h3>{selectedRowData.loading_station}</h3>
                                {/* <span>{selectedRowData.loading_name}</span> */}
                                <span>
                                    {selectedRowData.loading_name && selectedRowData.loading_name?.length > 20
                                        ? `${selectedRowData.loading_name.slice(0, 20)}...`
                                        : selectedRowData.loading_name}
                                </span>
                                <div className='mt-3'>
                                    <p>Scheduled - <b>{selectedRowData.loading_date_scheduled} <span></span></b> {/*CEST*/}</p>
                                    <p>Actual - <b>{selectedRowData.loading_date_actual} <span></span></b> {/*CEST*/}</p>
                                </div>
                            </div>
                            <div className='order_middle'>
                                <p><img src={Cargotruck} /></p>
                                <span>{selectedRowData.truck_number}</span>
                            </div>
                            <div className='order_view'>
                                <h3>{selectedRowData.unloading_station}</h3>
                                {/* <span>{selectedRowData.unloading_name}</span> */}
                                <span>
                                    {selectedRowData.unloading_name && selectedRowData.unloading_name?.length > 20
                                        ? `${selectedRowData.unloading_name.slice(0, 20)}...`
                                        : selectedRowData.unloading_name}
                                </span>
                                <div className='mt-3'>
                                    <p>Scheduled - <b>{selectedRowData.unloading_date_scheduled} <span></span></b> {/*CEST*/}</p>
                                    <p>ETA - <b>{selectedRowData.unloading_date_actual} <span></span></b> {/*CEST*/}</p>
                                </div>
                            </div>
                        </div>
                        <div className='mb-3'>
                            <ProgressBar animated now={50} style={{ height: "5px" }} />
                        </div>
                        <div className='mrn_edit'>

                            <ul>
                                <li>
                                    <span>MRN</span>
                                    <Form.Control type="text" placeholder="MRN" name='mrn' disabled={editMrnCrm !== 'mrn'} onChange={changeMrnCrm} value={mrnCrm?.mrn} />
                                    <Link to='#' className="barcode"><FontAwesomeIcon icon={faBarcode} /></Link>
                                    {editMrnCrm !== 'mrn' ?
                                        <Link to='#' onClick={() => handleEdtitMrnCrm('mrn')}><FontAwesomeIcon icon={faPencil} /></Link>
                                        :
                                        <Link to='#' onClick={updateMrnCrm}><FontAwesomeIcon icon={faCircleCheck} /></Link>
                                    }
                                </li>
                                {/* <li>
                                    <span>CRM</span>
                                    <Form.Control type="text" placeholder="CRM" name='crm' disabled={editMrnCrm !== 'crm'} onChange={changeMrnCrm} value={mrnCrm?.crm} />
                                    {editMrnCrm !== 'crm' ?
                                        <Link to='#' onClick={() => handleEdtitMrnCrm('crm')}><FontAwesomeIcon icon={faPencil} /></Link>
                                        :
                                        <Link to='#' onClick={updateMrnCrm}><FontAwesomeIcon icon={faCircleCheck} /></Link>
                                    }
                                </li> */}
                            </ul>

                        </div>
                        <div className='movment_history'>
                            <h3>Status Updates</h3> {/*<Link to='#' onClick={movementHistoryClick}>View All</Link>*/}
                        </div>
                        <div className='movment_list'>
                            <ul>
                                {selectedRowData && selectedRowData?.status_updates.map((history, index) => (
                                    <li>
                                        <span className='movem w-auto'>{history.status}</span>
                                        <span className='mvdate'>{history.date}&nbsp;&nbsp;&nbsp;&nbsp;{history.time}</span>
                                        {/* <Link to='#' >Details</Link> onClick={() => handleDetailsClick(history)} */}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <ImageUpload
                            ref={imageUploadRef}
                            attachable_type={"rfs_order"}
                            attachable_id={selectedRowData.order_id}
                            attachments={selectedRowData.attachments}
                            onDeleteSuccess={() => loadDetails(selectedRowData.order_id)}
                        />
                        <ActivityComments
                            commentable_type={"rfs_order"}
                            commentable_id={selectedRowData.order_id}
                            allactivities={selectedRowData.activities}
                            onReloadDetails={() => loadDetails(selectedRowData.order_id)}
                        />
                    </div>
                )}
            </div>
            <Modal show={isModal} onHide={closeModal} className="addfrom " centered size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Order Status</Modal.Title>
                    <p className='p_formal'>Update the truck order status below.</p>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm='7'>
                            <div className='missing_info'>
                                <h4>Update Document Status</h4>
                                <p>Update the status of the documentation Below.</p>
                                <Form.Group className='doc_status'>
                                    <Form.Check
                                        id="doc_status_open"
                                        label="Open"
                                        type='radio'
                                        name='doc_status'
                                        value="O"
                                        checked={docStatus === 'O'}
                                        onChange={handleRadioChange}
                                    />
                                    <Form.Check
                                        id="doc_status_processing"
                                        label="Processing"
                                        type='radio'
                                        name='doc_status'
                                        value="P"
                                        checked={docStatus === 'P'}
                                        onChange={handleRadioChange}
                                    />
                                    <Form.Check
                                        id="doc_status_completed"
                                        label="Completed"
                                        type="radio"
                                        name="doc_status"
                                        value="C"
                                        checked={docStatus === "C"}
                                        onChange={handleRadioChange}
                                    />
                                </Form.Group>
                            </div>
                            <div className='missing_info mt-3 mb-0'>
                                <h4>RCF Status</h4>
                                <p>Update the RCF status of the shipment bellow.</p>
                                <div>
                                    <Table className='awbset'>
                                        <thead>
                                            <tr>
                                                <th>Awb no.</th>
                                                <th>Status</th>
                                                <th>PCS</th>
                                                <th>RCF</th>
                                                <th>MAN</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {statusData?.map((data, index) => (

                                                <tr key={index}>{ }
                                                    <td>{data.airway_bill}</td>
                                                    <td>
                                                        {data.pick_status?.map((status, index) => (
                                                            <span className={status.color_status || ''}>{status.status || ''}</span>
                                                        ))}
                                                        {/* <span className='rcf_cl'>RCF</span> <span className='msca_cl'>MSCA</span>*/}
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            type="number"
                                                            placeholder=""
                                                            value={data.pieces}
                                                            disabled // ={editStatusIndex !== index}
                                                            className='' // {editStatusIndex === index ? 'awbset_edit' : ''}
                                                            onChange={(e) => handleFieldChange(index, 'pieces', e.target.value)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            type="number"
                                                            placeholder=""
                                                            value={data.rcf}
                                                            disabled={editStatusIndex !== index}
                                                            className={editStatusIndex === index ? 'awbset_edit' : ''}
                                                            onChange={(e) => handleFieldChange(index, 'rcf', e.target.value)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            type="number"
                                                            placeholder=""
                                                            value={data.man}
                                                            disabled={editStatusIndex !== index}
                                                            className={editStatusIndex === index ? 'awbset_edit' : ''}
                                                            onChange={(e) => handleFieldChange(index, 'man', e.target.value)}
                                                        />
                                                    </td>
                                                    <td>{editStatusIndex !== index ? <Link to='#' onClick={() => handleEditRow(index)}><img src={pen} /></Link> : <Link to='#' onClick={handleEditCompleteRow}><FontAwesomeIcon icon={faCircleCheck} /></Link>}</td>
                                                </tr>

                                            ))}
                                            {/* <tr>
                                                <td>999-6125 1026</td>
                                                <td><span className='rcf_cl'>RCF</span> <span className='msca_cl'>MSCA</span></td>
                                                <td><Form.Control type="email" placeholder="" /></td>
                                                <td><Form.Control type="email" placeholder="" /></td>
                                                <td><Link><img src={pen} /></Link></td>
                                            </tr>
                                            <tr>
                                                <td>999-6125 1026</td>
                                                <td><span className='rcf_cl'>RCF</span> <span className='msca_cl'>MSCA</span></td>
                                                <td><Form.Control type="email" placeholder="" /></td>
                                                <td><Form.Control type="email" placeholder="" /></td>
                                                <td><Link><img src={pen} /></Link></td>
                                            </tr> */}

                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </Col>
                        <Col sm='5'>
                            <div className='missing_info h-100'>
                                <h4>Order Overview</h4>
                                <p>Overview of the truck order</p>
                                <ul>
                                    <li> <span>Order No </span><span>: {modalData?.order_number}</span> </li>
                                    <li> <span>Truck No </span><span>: {modalData?.truck_number}</span> </li>
                                    <li> <span>Truck Date </span><span>: {modalData?.loading_date_planned}</span> </li>
                                    <li> <span>ETA Truck  </span><span>: {modalData?.unloading_date_planned}</span> </li>
                                </ul>
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" className='w-25 mx-auto' onClick={updateStatus}>Update Status</Button>
                </Modal.Footer>
            </Modal>
            <Modal className='addfrom in_oparation' show={showConfirmation} onHide={closeConf} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Print LA</Modal.Title>
                    <p>The DOCS status of selected orders will change to Processing</p>
                </Modal.Header>
                <Modal.Body>
                    <div className='d-flex flex-wrap inop opara_w'>
                        {/* {selectedRowData ? (
                            <div className='inbox'><span>{selectedRowData.order_number}</span></div>
                        ) : ( */}
                        <>{gridSelect && gridSelect.map((num, index) => (

                            <div key={index} className='inbox'>
                                <span>{num.order_number}</span>
                                <img src={Trash} alt='' onClick={() => handleRemove(num.order_id)} />
                            </div>
                        ))}
                        </>
                        {/* )} */}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleConfirmChange}>
                        Print
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={actArcModal} onHide={() => setActArcModal(false)} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                {/* <Modal.Body>
                    <h3>Selected {gridSelect.length > 1 ? "Order's" : 'Order'} will move to {activeTab == 'Active' ? 'Archive' : 'Active'}</h3>
                    <p>Are you sure you want to move {gridSelect.length > 1 ? "Order's" : 'Order'} to {activeTab == 'Active' ? 'Archive' : 'Active'}?</p>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="secondary" onClick={() => setActArcModal(false)}>
                            No
                        </Button>
                        <Button variant="primary" onClick={confirmMoveToActArc}>
                            Yes
                        </Button>
                    </div>
                </Modal.Footer> */}
                <Modal.Body>
                    {/* <h3>Selected {gridSelect.length > 1 ? "Order's" : 'Order'} will move to {activeTab == 'Active' ? 'Archive' : 'Active'}</h3>
                    <p>Are you sure you want to move {gridSelect.length > 1 ? "Order's" : 'Order'} to {activeTab == 'Active' ? 'Archive' : 'Active'}?</p> */}
                    {
                        moveToComplete ? (
                            <>
                                <h3>Selected Order's will move to Complete</h3>
                                <p>Are you sure you want to move Order's to Complete?</p>
                            </>
                        ) : (
                            <>
                                <h3>Selected {gridSelect.length > 1 ? "Order's" : 'Order'} will move to {activeTab === 'Active' ? 'Archive' : 'Active'}</h3>
                                <p>Are you sure you want to move {gridSelect.length > 1 ? "Order's" : 'Order'} to {activeTab === 'Active' ? 'Archive' : 'Active'}?</p>
                            </>
                        )
                    }
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="secondary" onClick={() => setActArcModal(false)}>
                            No
                        </Button>
                        {
                            moveToComplete ? (
                                <>
                                    <Button variant="primary" onClick={confirmMoveToComplete}>
                                        Yes
                                    </Button>
                                </>
                            ) : (
                                <>
                                    <Button variant="primary" onClick={confirmMoveToActArc}>
                                        Yes
                                    </Button>
                                </>
                            )
                        }

                    </div>
                </Modal.Footer>
            </Modal>
            <Modal show={schdlModal} onHide={() => { setSchdlModal(false); setSelectedOrderId(null); }} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    {schdlModalData === 'SCH' &&
                        <>
                            <h3>Handling Time</h3>
                            <p>Update the truck order status below</p>

                            {/* <h3>Time Overview</h3>
                        <p>Overview of truck order</p> */}

                            <div className='scdule_pop mb-3'>
                                <div class="d-flex justify-content-between">
                                    <h5>Trip Details</h5>
                                    {vehicleView.vehicle_id && vehicleView.order_number && (
                                        <h5
                                            onClick={() => {
                                                const vvFilter = [{ datafield: "vehicle_no", filters: [{ condition: "EQUAL", operator: 1, value: vehicleView.vehicle_id }] }, { datafield: "order_number", filters: [{ condition: "CONTAINS", operator: 1, value: vehicleView.order_number }] }];
                                                localStorage.setItem('vvFilter', JSON.stringify(vvFilter));
                                                localStorage.setItem("Htab", "vehicle");
                                                window.location.reload();
                                            }}
                                        ><u>Vehicle View</u>
                                        </h5>
                                    )}
                                </div>
                                <Row>
                                    <Col md={6}>
                                        <p className="text-start"><strong>Gate In: </strong> {changedData?.gateIn?.slice(0, 16)} </p>
                                        <p className="text-start"><strong>Driver Name 1 :</strong></p>
                                        <p className="text-start"><strong>Driver Name 2 :</strong></p>
                                    </Col>
                                    <Col md={6}>
                                        <p className="text-start"><strong>Gate Out: </strong> {changedData?.gateOut?.slice(0, 16)} </p>
                                        <p className="text-start">{changedData?.driver_name1}</p>
                                        <p className="text-start">{changedData?.driver_name2}</p>
                                    </Col>
                                </Row>

                            </div>
                            <div className='scdule_pop'>
                                <h5>Orders Time Overview</h5>
                                <Table hover>
                                    <thead>
                                        <tr>
                                            <th>Order No</th>
                                            <th>Truck No</th>
                                            <th>Vehicle</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orderVehicle?.map((truck) => (
                                            <tr key={truck.id}>
                                                <td>{truck.order_number}</td>
                                                <td>{truck.truck_number}</td>
                                                <td>{truck.vehicle_id}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>

                                <Row className="mb-2 align-items-center">
                                    <Col lg={4}><Form.Label>Office In:</Form.Label></Col>
                                    <Col lg={8}>
                                        <input type="datetime-local" name="officeIn" className='form-control' value={changedData.officeIn} onChange={handleChange} placeholder="Office In" />
                                    </Col>
                                </Row>

                                <Row className='align-items-center'>
                                    <Col lg={4}><Form.Label>Office Out:</Form.Label></Col>
                                    <Col lg={8}>
                                        <input type="datetime-local" name="officeOut" className='form-control' value={changedData.officeOut} onChange={handleChange} placeholder="Office Out" />
                                    </Col>
                                </Row>

                                {/* <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
                                    <Form.Label>Office In:</Form.Label>
                                    <input type="datetime-local" name="officeIn" className='form-control' value={changedData.officeIn} onChange={handleChange} placeholder="Office In" />
                                </Form.Group>

                                <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
                                    <Form.Label>Office Out: </Form.Label>
                                    <input type="datetime-local" name="officeOut" className='form-control' value={changedData.officeOut} onChange={handleChange} placeholder="Office Out" />
                                </Form.Group> */}

                            </div>
                            <div className="mt-3 scdule_pop_loading">

                                <Row className="mb-2 align-items-center">
                                    <Col lg={4}><Form.Label>Start Loading:</Form.Label></Col>
                                    <Col lg={8}>
                                        <input type="datetime-local" name="startLoading" className='form-control' value={changedData.startLoading} onChange={handleChange} placeholder="Start Loading" />
                                    </Col>
                                </Row>
                                <Row className="align-items-center">
                                    <Col lg={4}><Form.Label>End Loading:</Form.Label></Col>
                                    <Col lg={8}>
                                        <input type="datetime-local" name="endLoading" className='form-control' value={changedData.endLoading} onChange={handleChange} placeholder="End Loading" />
                                    </Col>
                                </Row>

                                {/* <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
                                    <Form.Label>Start Loading:</Form.Label>
                                    <input type="datetime-local" name="startLoading" className='form-control' value={changedData.startLoading} onChange={handleChange} placeholder="Start Loading" />
                                </Form.Group>

                                <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
                                    <Form.Label>End Loading:</Form.Label>
                                    <input type="datetime-local" name="endLoading" className='form-control' value={changedData.endLoading} onChange={handleChange} placeholder="End Loading" />
                                </Form.Group> */}

                            </div>
                        </>
                    }
                    {schdlModalData === 'DEL' &&
                        <>
                            <h3>Irregularity Status</h3>
                            <p>Update the Irregularity status below</p>

                            <div className='scdule_pop mb-3'>
                                <h5>Orders Overview</h5>
                                <Table hover>
                                    <thead>
                                        <tr>
                                            <th>Order No</th>
                                            <th>Truck No</th>
                                            <th>Vehicle</th>
                                            <th>Delay</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orderVehicle?.map((truck) => {
                                            const hasData = changedData.orders?.[truck.order_id];
                                            const isSelected = selectedOrderId === truck.order_id;

                                            return (
                                                <tr
                                                    key={truck.id}
                                                    onClick={() => setSelectedOrderId(truck.order_id)}
                                                    className={` ${isSelected ? 'bg-selected' : hasData ? 'bg-data' : 'bg-transparent'
                                                        }`}
                                                >
                                                    <td>{truck.order_number}</td>
                                                    <td>{truck.truck_number}</td>
                                                    <td>{truck.vehicle_id}</td>
                                                    <td>
                                                        {truck.delay_status == null ? (
                                                            <img
                                                                className="jqx-grid-cell-left-align delay_click"
                                                                style={{ width: '25px' }}
                                                                src={DelayD}
                                                                alt="DelayD"
                                                            />
                                                        ) : (
                                                            <img
                                                                className="jqx-grid-cell-left-align delay_click"
                                                                style={{ width: '25px' }}
                                                                src={DelayA}
                                                                alt="DelayA"
                                                            />
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>
                            </div>

                            {selectedOrderId && (
                                <>
                                    <div className='scdule_pop mb-3'>
                                        <h5>Delay Status ({selectedOrder?.order_number})</h5>
                                        <Select
                                            isMulti
                                            options={delayOptions}
                                            onChange={(selectedOptions) => {
                                                const newOrders = { ...changedData.orders };
                                                newOrders[selectedOrderId] = {
                                                    ...(newOrders[selectedOrderId] || {}),
                                                    delay_status: selectedOptions.map((option) => option.value),
                                                };
                                                setChangedData((prev) => ({
                                                    ...prev,
                                                    orders: newOrders,
                                                }));
                                            }}
                                            placeholder="Delay Status"
                                            className='rfs_autoslct'
                                            name="delay_status"
                                            value={delayOptions.filter((option) =>
                                                changedData.orders?.[selectedOrderId]?.delay_status?.includes(option.value)
                                            )}
                                        />
                                    </div>

                                    <div className='scdule_pop mb-3'>
                                        <h5>Delay Remarks ({selectedOrder?.order_number})</h5>
                                        <textarea
                                            className="form-control"
                                            placeholder="Enter delay remarks"
                                            value={changedData.orders?.[selectedOrderId]?.delay_remarks || ''}
                                            onChange={(e) => {
                                                const newOrders = { ...changedData.orders };
                                                newOrders[selectedOrderId] = {
                                                    ...(newOrders[selectedOrderId] || {}),
                                                    delay_remarks: e.target.value,
                                                };
                                                setChangedData((prev) => ({
                                                    ...prev,
                                                    orders: newOrders,
                                                }));
                                            }}
                                        />
                                    </div>
                                </>
                            )}
                        </>
                    }


                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="primary" onClick={schdlModalData === 'SCH' ? updateTime : updateIrregularity}>
                            Update Status
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal show={confirmEmailModal} onHide={() => { setConfirmEmailModal(false) }} className='addfrom change_type' centered size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Ready for Pickup Confirmation Email</Modal.Title>
                    <p className={'text-start'}>Please confirm the warehouse before sending the email to the trucker</p>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm='5'>
                            <div className='missing_info'>
                                <h4>Update Document Status</h4>
                                <p>Update the status of the documentation Below.</p>
                                <Form.Group className='doc_status'>
                                    <Form.Check
                                        id="doc_status_open"
                                        label="Open"
                                        type='radio'
                                        name='doc_status'
                                        value="O"
                                        checked={docStatus === 'O'}
                                        onChange={handleRadioChange}
                                    />
                                    <Form.Check
                                        id="doc_status_processing"
                                        label="Processing"
                                        type='radio'
                                        name='doc_status'
                                        value="P"
                                        checked={docStatus === 'P'}
                                        onChange={handleRadioChange}
                                    />
                                    <Form.Check
                                        id="doc_status_completed"
                                        label="Completed"
                                        type="radio"
                                        name="doc_status"
                                        value="C"
                                        checked={docStatus === "C"}
                                        onChange={handleRadioChange}
                                    />
                                </Form.Group>
                            </div>
                            <div className='availableSlot mt-3'>
                                {/* {allAvailableSlotCount?.map((avilableSlot, index) => (
                                    <>
                                        <p>Date: {avilableSlot.date}</p>
                                        <p>Available Slot: {avilableSlot.available_no_of_slot}</p>
                                        <ul>
                                            {avilableSlot.available_slots?.map((slot, index) => (
                                                <li key={index}>
                                                    <strong>Door No:</strong> {slot.door_no} <br />
                                                    <strong>Start:</strong> {slot.start_time} <br />
                                                    <strong>End:</strong> {slot.end_time}
                                                </li>
                                            ))}
                                        </ul>
                                    </>
                                ))} */}
                                <Form.Group className='doc_status'>
                                    <h4>Warehouse List</h4>
                                    <Select
                                        name="warehouse_list"
                                        options={warehouselist}
                                        value={warehouselist.find(opt => opt.value === confirmFormData.warehouse_list)}
                                        onChange={(selected) =>
                                            handleConfirmModalChange('warehouse_list', selected?.value ?? '')
                                        }
                                        placeholder="Warehouse List"
                                    />
                                </Form.Group>
                                <hr />
                                <>
                                    <h4>Selection of Door</h4>
                                    <p>Date: {allAvailableSlotCount?.[0]?.date}</p>
                                    {/* <p>Available Slot: {allAvailableSlotCount?.[0]?.available_no_of_slot}</p> */}
                                    <ul>
                                        <li key={0}>
                                            <span className='me-2'>Door No:</span><span className='ms-2'>{allAvailableSlotCount?.[0]?.available_slots?.[0]?.door_no}</span>
                                        </li>
                                        <li><span className='me-2'>Start:</span><span className='ms-2'>  {allAvailableSlotCount?.[0]?.available_slots?.[0]?.start_time}</span> </li>
                                        <li> <span className='me-2'>End:</span> <span className='ms-2'> {allAvailableSlotCount?.[0]?.available_slots?.[0]?.end_time}</span></li>
                                    </ul>
                                </>
                            </div>
                        </Col>
                        <Col sm='7'>
                            <div className='missing_info'>
                                <h4>Order Overview</h4>
                                <p>Overview of the truck order</p>
                                <ul>
                                    <li> <span>Order No </span><span>: {modalData?.order_number}</span> </li>
                                    <li> <span>Truck No </span><span>: {modalData?.truck_number}</span> </li>
                                    <li> <span>Truck Date </span><span>: {modalData?.loading_date_planned}</span> </li>
                                    <li> <span>ETA Truck  </span><span>: {modalData?.unloading_date_planned}</span> </li>
                                </ul>
                            </div>
                            <div className='missing_info mt-3 mb-0'>
                                <h4>RCF Status</h4>
                                <p>Update the RCF status of the shipment bellow.</p>
                                <div>
                                    <Table className='awbset'>
                                        <thead>
                                            <tr>
                                                <th>Awb no.</th>
                                                <th>Status</th>
                                                <th>PCS</th>
                                                <th>RCF</th>
                                                <th>MAN</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {statusData?.map((data, index) => (
                                                <tr key={index}>{ }
                                                    <td>{data.airway_bill}</td>
                                                    <td>
                                                        {data.pick_status?.map((status, index) => (
                                                            <span className={status.color_status || ''}>{status.status || ''}</span>
                                                        ))}
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            type="number"
                                                            placeholder=""
                                                            value={data.pieces}
                                                            disabled
                                                            className=''
                                                            onChange={(e) => handleFieldChange(index, 'pieces', e.target.value)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            type="number"
                                                            placeholder=""
                                                            value={data.rcf}
                                                            disabled={editStatusIndex !== index}
                                                            className={editStatusIndex === index ? 'awbset_edit' : ''}
                                                            onChange={(e) => handleFieldChange(index, 'rcf', e.target.value)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            type="number"
                                                            placeholder=""
                                                            value={data.man}
                                                            disabled={editStatusIndex !== index}
                                                            className={editStatusIndex === index ? 'awbset_edit' : ''}
                                                            onChange={(e) => handleFieldChange(index, 'man', e.target.value)}
                                                        />
                                                    </td>
                                                    <td>{editStatusIndex !== index ? <Link to='#' onClick={() => handleEditRow(index)}><img src={pen} /></Link> : <Link to='#' onClick={handleEditCompleteRow}><FontAwesomeIcon icon={faCircleCheck} /></Link>}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    {/* <div className='missing_info'>
                        <h4>Update Document Status</h4>
                        <p>Update the status of the documentation Below.</p>
                        <Form.Group className='doc_status'>
                            <Form.Check
                                id="doc_status_open"
                                label="Open"
                                type='radio'
                                name='confirm_doc_status'
                                value="O"
                                checked={confirmFormData.docStatus === 'O'}
                                onChange={(e) => handleConfirmModalChange('docStatus', e.target.value)}
                            />
                            <Form.Check
                                id="doc_status_processing"
                                label="Processing"
                                type='radio'
                                name='confirm_doc_status'
                                value="P"
                                checked={confirmFormData.docStatus === 'P'}
                                onChange={(e) => handleConfirmModalChange('docStatus', e.target.value)}
                            />
                            <Form.Check
                                id="doc_status_completed"
                                label="Completed"
                                type="radio"
                                name='confirm_doc_status'
                                value="C"
                                checked={confirmFormData.docStatus === "C"}
                                onChange={(e) => handleConfirmModalChange('docStatus', e.target.value)}
                            />
                        </Form.Group>
                    </div>
                    <Form.Group className='doc_status'>
                        <Form.Label>Warehouse List</Form.Label>
                        <Select
                            name="warehouse_list"
                            options={warehouselist}
                            value={warehouselist.find(opt => opt.value === confirmFormData.warehouse_list)}
                            onChange={(selected) =>
                                handleConfirmModalChange('warehouse_list', selected?.value ?? '')
                            }
                            placeholder="Warehouse List"
                        />
                    </Form.Group> */}
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex w-50 mx-auto are_bottom">
                        <Button variant="secondary" onClick={() => { setConfirmEmailModal(false) }}> Close</Button>
                        <Button variant="primary" disabled={sendingMail} onClick={() => handleSaveMail()}> {sendingMail ? "Sending..." : "Send Mail"}</Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
};

export default OrdersView;